<template>
  <div class="AllItemBank">
    <div class="main">
      <el-table :data="allItemBankList" style="width: 100%">
        <el-table-column label="题库名称">
          <template slot-scope="scope">
                <div class="courses-card" @click="gotoRouterDetaills(scope.row.courseid)">
                    <div class="img"><img v-lazy="scope.row.coverurl" :alt="scope.row.subject"></div>
                    <div class="msg">
                      <p class="text-overflow">{{scope.row.subject}}</p>
                      <p class="money"><template v-if="scope.row.qbtype == 1">单试卷</template><template v-else>系列试卷</template></p>
                    </div>
                  </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100px" align="right">
          <template slot-scope="scope">
              <p class="gorouter" @click="clickTestPaperPopu(scope.row.courseid)">进入考试</p>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :current-page.sync='allItemBank.page'  @current-change="handleCurrentChange" :total="rowCount"> </el-pagination>
    </div>

    <ItemBankDialog ref="itemBankDialog"></ItemBankDialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {getAllQuestionbankByUser} from 'api/personalCenterApi'
import ItemBankDialog from './../components/itemBankDialog'
export default {
  name: 'AllItemBank',
  data () {
    return {
      allItemBankList: [],  // 全部题库列表
      allItemBank: {page: 1, pageSize: 10},  // 接口api
      rowCount:1,
     
    }
  },
  mounted () {
    this.getallItemBankLists(1)
  },
  methods: {
    getallItemBankLists(page) {  // 全部题库api
      // console.log(page)
      this.setLoading(true)
      getAllQuestionbankByUser({
        data: {page: page, pageSize: 10},
        success: data => {
          this.setLoading(false)
          this.allItemBankList = data.data.content
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
      // this.allItemBankList = [{"coursetype":1,"coverurl":"http://innertest.img.capwhale.com/kmc/content/20200211/26c9d1696a0944d98d8ecf93e4ea0fb3","subject":"大力汽修学院 周三免费汽修培训课","iscomment":0,"courseid":"pHOFcAqCh97dbr0N","isjointable":1},{"coursetype":2,"coverurl":"http://innertest.img.capwhale.com/kmc/content/20200211/c000a2da42bc4650b9676b39ea6a071e","subject":"老路：用得上的商学课","iscomment":1,"courseid":"kapIVslOzSXNJFZj","isjointable":0},{"coursetype":1,"coverurl":"http://innertest.img.capwhale.com/kmc/content/20200211/9b75fcbbfcbd412699e79a629a429e77","subject":"景观建筑-小镜带你精学Sketchup","iscomment":0,"courseid":"u7nmrTedtNdw8j23","isjointable":1},{"coursetype":2,"coverurl":"http://innertest.img.capwhale.com/kmc/content/20200211/631d9ec75a5e4a1490a96ca4153089be","subject":"12堂超级搜索术，快速找到你想找的任何信息！资源！人脉！","iscomment":0,"courseid":"SykF3oi2Uwz5xzgf","isjointable":0},{"coursetype":2,"coverurl":"http://innertest.img.capwhale.com/kmc/matimage/20190724/8a525658025d486080fdb13407a4d47d","subject":"三年教育5年模拟，高数精品课程2","iscomment":1,"courseid":"vjtcDceAZVm6Bjlm","isjointable":1},{"coursetype":2,"coverurl":"http://innertest.img.capwhale.com/kmc/content/20200211/0d8d0a10dbfd4703b36a122982819dde","subject":"EXCEL高级函数班，职场必备技能（办公软件、制作表格）","iscomment":1,"courseid":"aVsyFjlgNSWMYuqb","isjointable":1},{"coursetype":2,"coverurl":"http://innertest.img.capwhale.com/kmc/content/20200211/ae308cd2b66a41beb90f44111eff7ee0","subject":"【核心课】3Dmax室外建筑效果图建筑表现-建筑设计/渲染/PS后期","iscomment":0,"courseid":"ogFQqvfNTb8KtYb0","isjointable":0},{"coursetype":1,"coverurl":"http://innertest.img.capwhale.com/kmc/content/20200211/a9a8c2fad277434181eb0f3f882e5cc4","subject":"【思睿电商】 2020年终冲刺班","iscomment":0,"courseid":"1qCn5IjTPUoyV3IV","isjointable":0},{"coursetype":2,"coverurl":"http://innertest.img.capwhale.com/kmc/content/20200211/4ac47838ea9b41219d765b65e23241c4","subject":"【全套】Excel/WPS零基础入门(电子表格)小白脱白系列","iscomment":0,"courseid":"j8wgTWo08oUPI1Sv","isjointable":0},{"coursetype":2,"coverurl":"http://innertest.img.capwhale.com/kmc/content/20200221/c56cc272ff0b4482851a1d603095565f","subject":"2020年未来教育计算机二级ms office全程班","iscomment":0,"courseid":"vWBQpVmbJhdNg82u","isjointable":0}]
    },
    clickTestPaperPopu(bankid) {  // 考试弹窗
      this.$refs.itemBankDialog.startItemBankDialog(bankid)
    },
    handleCurrentChange(page) { // 翻页
      this.getallItemBankLists(page)
    },
    gotoRouterDetaills(qid) {  // 前往详情页面
    const { href } = this.$router.resolve({
                name: "QuestionDetails",
                query: {
                    qid: qid
                }
              })
              window.open(href, '_blank');
    },
    ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
    ItemBankDialog
  }
}
</script>

<style lang="scss" type="text/scss" scope>
.AllItemBank {
  .gorouter {
    color: #303133;
    cursor: pointer;

    &:hover {
      color: #409EFF;
    }
  }

}
</style>